module.exports = __webpack_public_path__ + "static/img/construct4.5129ff47.png";